import { ref, toRef, watch } from 'vue';
import { useAnimatedCount } from '../../composables/useAnimatedCount.js';

export default (props, { emit }) => {
  const labelFor = (openOnly) => (openOnly ? props.items[1] : props.items[0]);

  const selectedItem = ref(labelFor(props.modelValue));
  const selected = ref(labelFor(props.modelValue));

  // Watch for changes in modelValue to update the display
  watch(() => props.modelValue, (newValue) => {
    selectedItem.value = labelFor(newValue);
    selected.value = labelFor(newValue);
  }, { immediate: false });

  // First change snaps, later changes animate (variant A)
  const { displayCount } = useAnimatedCount(toRef(props, 'count'));

  const handleSelectionChange = (value) => {
    emit('update:modelValue', value === props.items[1]);
  };

  return {
    selectedItem,
    selected,
    displayCount,
    handleSelectionChange,
  };
};
